export const productGalleryInit = () => {
  if(document.querySelector('.product-gallery')) {
    const main = new window.splide('#productGalleryMain', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });
  
    const thumbnails = new window.splide('#productGalleryThumbnails', {
      perPage: 3,
      gap: '8px',
      rewind: true,
      pagination: false,
      isNavigation: true,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          gap: '20px',
        },
        992: {
          perPage: 4,
        },
        1400: {
          perPage: 5,
        },
      }
    });
  
    thumbnails.on('overflow', function (isOverflow) {
      if (!isOverflow) {
        thumbnails.go(0);
  
        thumbnails.options = {
          arrows: isOverflow,
          pagination: isOverflow,
          drag: isOverflow,
          clones: isOverflow ? undefined : 0,
        };
      }
    });
  
    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }
}